module.exports = __webpack_public_path__ + "static/media/Folder.a870077b.png";